import { Box, Button } from '@modusign/design-system';

import embeddedService from '@app/libs/embedded/embeddedService';

interface TemplateSignerSetupFooterProps {
  backButtonText: string;
  disableButton: boolean;
  nextButtonText: string;
  onBackStepClick: () => void;
  onNextStepClick: () => void;
}

function TemplateSignerSetupFooter({
  backButtonText,
  disableButton,
  nextButtonText,
  onBackStepClick,
  onNextStepClick,
}: TemplateSignerSetupFooterProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'darkGray700',
        bottom: 0,
        color: 'white',
        left: 0,
        paddingTop: '12px',
        whiteSpace: 'nowrap',
        width: '100%',
        zIndex: 500, // $z-index-fixed-layout
      }}
    >
      <Box sx={{ marginBottom: 4, minHeight: '38px', textAlign: 'center' }}>
        {!embeddedService.isEmbedded && (
          <Button
            backgroundColor="darkGray500"
            color="lightGray800"
            height={48}
            mr={2}
            sx={{
              borderColor: 'darkGray500',
              '&:hover': {
                backgroundColor: 'darkGray400',
              },
            }}
            width={180}
            onClick={onBackStepClick}
          >
            {backButtonText}
          </Button>
        )}
        <Button
          disabled={disableButton}
          height={48}
          variant="primary"
          width={180}
          onClick={onNextStepClick}
        >
          {nextButtonText}
        </Button>
      </Box>
    </Box>
  );
}

export default TemplateSignerSetupFooter;
